import { IconButton } from '@/components/forms/IconButton';
import { NotificationBell } from './NotificationBell';
import { UserMenu, type UserMenuProps } from './UserMenu';

/** Barra do topo direito do checkout (`.ck-top`): ajuda, sino e loja. */
export function TopBar({ notifications = 3, user }: { notifications?: number; user: UserMenuProps }) {
  return (
    <div className="ck-top">
      <IconButton icon="help" label="Ajuda" variant="plain" />
      <NotificationBell count={notifications} plain />
      <span className="vsep"></span>
      <UserMenu {...user} />
    </div>
  );
}
